import { CustomDate } from '../../components';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

const SearchSection = props => {
    const {
        setDateValue,
        prevDateValue,
        setPrevDateValue,
        addProp,
        configOptions,
        customStyles,
        isResetDate,
    } = props;
    return (
        <div className="search-sec">
            <CustomDate
                setDateValue={setDateValue}
                setPrevDateValue={setPrevDateValue}
                prevDateValue={prevDateValue}
                defaultSelected={{ label: 'Today', value: 'today' }}
                addProp={addProp}
                configOptions={configOptions}
                customStyles={customStyles}
                isResetDate={isResetDate}
            />
        </div>
    );
};

SearchSection.propTypes = {
    actions: PropTypes.object,
    setDateValue: PropTypes.func,
    prevDateValue: PropTypes.string,
    setPrevDateValue: PropTypes.func,
    addProp: PropTypes.func,
    configOptions: PropTypes.array,
    customStyles: PropTypes.object,
    isResetDate: PropTypes.bool,
};

export default reduxForm({
    form: 'search-section',
})(SearchSection);
